import {
  SxProps,
  Theme,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  Typography
} from "@mui/material";
import { Devices, RoomService } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { StyledIconComponent } from "../../../components/Reports/CapacityFilter/DateAndTypeSelector/booking-type-selector.partial";
import type { ResourceKind } from "../typings/resource-calendar.types";

type ScheduleResourceKindToggleProps = {
  selectedKind: ResourceKind | null;
  onResourceKindChange: (kind: ResourceKind) => void;
  buttonStyle?: SxProps<Theme>;
  iconSize?: string;
};

export function ScheduleResourceKindToggle({
  selectedKind,
  onResourceKindChange,
  buttonStyle,
  iconSize = "20px"
}: Readonly<ScheduleResourceKindToggleProps>) {
  const { t } = useTranslation();

  return (
    <ToggleButtonGroup
      exclusive
      value={selectedKind ?? false}
      onChange={(_event, nextKind: ResourceKind | null) => {
        if (nextKind != null) {
          onResourceKindChange(nextKind);
        }
      }}
      data-testid="schedule-resource-kind-toggle"
      sx={{ display: "flex", flexWrap: "nowrap" }}
    >
      <Tooltip title={<Typography>{t("Equipment")}</Typography>} arrow>
        <ToggleButton
          value="equipment"
          aria-label={t("Equipment")}
          data-testid="schedule-resource-kind-equipment"
          sx={buttonStyle ? { ...buttonStyle } : {}}
        >
          <StyledIconComponent iconSize={iconSize}>
            <Devices width={iconSize} height={iconSize} />
          </StyledIconComponent>
        </ToggleButton>
      </Tooltip>
      <Tooltip title={<Typography>{t("Catering")}</Typography>} arrow>
        <ToggleButton
          value="catering"
          aria-label={t("Catering")}
          data-testid="schedule-resource-kind-catering"
          sx={buttonStyle ? { ...buttonStyle } : {}}
        >
          <StyledIconComponent iconSize={iconSize}>
            <RoomService width={iconSize} height={iconSize} />
          </StyledIconComponent>
        </ToggleButton>
      </Tooltip>
    </ToggleButtonGroup>
  );
}
